export const theme = {
  modalBackground: Styles.color.dialogBackground,
  disclaimerColor: Styles.color.grey.one,
};
